import { NotificationBanner } from '@/components/ui/notification-banner/notification-banner';
import { useScheduledPaymentsStatus } from '@/features/payments';
import { useProfilesData } from '@/features/user';

export function TrialBanner() {
  const { selectedCourse, selectedProfile } = useProfilesData();
  const { isPaymentPending } = useScheduledPaymentsStatus();

  // Show trial banner only if the selected course is on trial.
  if (!selectedCourse?.is_trial) {
    return null;
  }

  // Payment always supersedes trial: if ANY enrolled course has a payment due
  // (not just the selected one), suppress the trial banner so only the payment
  // banner shows.
  if (isPaymentPending) {
    return null;
  }

  const name = selectedProfile?.name?.split(' ')[0] ?? '';
  const title = name
    ? `Hey ${name}! You are in Trial Period`
    : 'You are in Trial Period';

  return (
    <NotificationBanner
      title={title}
      variant="info"
      size="sm"
      style={{ background: 'var(--color-cold-lips)' }}
    />
  );
}
